var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "laser_svg__laser_a",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".laser_svg__b{fill:#fff}.laser_svg__c{fill:red}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "laser_svg__c",
    d: "m206.22,55.2c-1.05,0-2.1-.4-2.9-1.2-1.6-1.6-1.6-4.2,0-5.8l5.8-5.8c1.6-1.6,4.2-1.6,5.8,0,1.6,1.6,1.6,4.2,0,5.8l-5.8,5.8c-.8.8-1.85,1.2-2.9,1.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "laser_svg__c",
    d: "m137.98,123.42c-1.05,0-2.1-.4-2.9-1.2-1.6-1.6-1.6-4.2,0-5.8l5.8-5.8c1.6-1.6,4.2-1.6,5.8,0,1.6,1.6,1.6,4.2,0,5.8l-5.8,5.8c-.8.8-1.85,1.2-2.9,1.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "laser_svg__c",
    d: "m211.51,123.42c-1.05,0-2.1-.4-2.9-1.2l-5.8-5.8c-1.6-1.6-1.6-4.2,0-5.8s4.2-1.6,5.8,0l5.8,5.8c1.6,1.6,1.6,4.2,0,5.8-.8.8-1.85,1.2-2.9,1.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "laser_svg__c",
    d: "m143.78,55.2c-1.05,0-2.1-.4-2.9-1.2l-5.8-5.8c-1.6-1.6-1.6-4.2,0-5.8s4.2-1.6,5.8,0l5.8,5.8c1.6,1.6,1.6,4.2,0,5.8-.8.8-1.85,1.2-2.9,1.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "laser_svg__c",
    d: "m175,42.64c-2.28,0-4.12-1.84-4.12-4.12v-8.25c0-2.28,1.84-4.12,4.12-4.12s4.12,1.84,4.12,4.12v8.25c0,2.28-1.84,4.12-4.12,4.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "laser_svg__c",
    d: "m227.25,86.64h-8.25c-2.28,0-4.12-1.84-4.12-4.12s1.84-4.12,4.12-4.12h8.25c2.28,0,4.12,1.84,4.12,4.12s-1.84,4.12-4.12,4.12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "laser_svg__c",
    d: "m131,86.64h-8.25c-2.28,0-4.12-1.84-4.12-4.12s1.84-4.12,4.12-4.12h8.25c2.28,0,4.12,1.84,4.12,4.12s-1.84,4.12-4.12,4.12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "laser_svg__c",
    d: "m175,59.81c-12.43,0-22.5,10.07-22.5,22.5s10.07,22.5,22.5,22.5,22.5-10.07,22.5-22.5-10.07-22.5-22.5-22.5h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "laser_svg__c",
    x: 164.93,
    y: 82.31,
    width: 20.13,
    height: 99.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "laser_svg__b",
    x: 156.26,
    y: 235.65,
    width: 37.49,
    height: 51.31,
    rx: 16.49,
    ry: 16.49
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "laser_svg__b",
    d: "m237.42,175.9h-124.83c-13.34-.41-24.53,9.99-25.08,23.33v118.32h175v-118.32c-.55-13.34-11.74-23.74-25.08-23.33Zm-37.67,94.56c0,12.4-10.09,22.49-22.49,22.49h-4.51c-12.4,0-22.49-10.09-22.49-22.49v-18.33c0-12.4,10.09-22.49,22.49-22.49h4.51c12.4,0,22.49,10.09,22.49,22.49v18.33Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaser);
export default __webpack_public_path__ + "static/media/laser.3e489941b5ec694d91fa34790255b042.svg";
export { ForwardRef as ReactComponent };